import styled from "styled-components";

export const Tech = styled.div`
  height: 50px;
  width: 85%;
  background-color: #121214;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-family: "Inter";
  font-weight: 600;
  cursor: pointer;
`;
